import { Root } from '@athena/forge';
import Banner from '../common/Banner';

const PASSWORD_REQUIREMENTS = [
  'Minimum 15 characters',
  'Maximum 72 characters',
  'Does not contain your username or email',
  'Does not contain your first name',
  'Does not contain your last name',
  'Not any of your last 30 passwords',
  'Not a weak or commonly used password',
];

/**
 * V2 of PasswordRequirements component with Forge Banner styling
 * Features:
 * - Static hardcoded password requirements list
 * - Purple left border with info icon
 * - Bold header text
 * - Smaller font size for list items
 */
export default function PasswordRequirementsV2 () {
  return (
    <Root>
      <div className="password-requirements-v2-info">
        <Banner alertType="info" headerText="Password Requirements">
          <ul className="password-requirements-v2--list">
            {PASSWORD_REQUIREMENTS.map((req, index) => (
              <li key={index}>
                {req}
              </li>
            ))}
          </ul>
        </Banner>
      </div>
    </Root>
  );
}
